import React from 'react';

import {
  Td,
  Th,
  TableColumnHeaderProps,
  TableCellProps,
} from '@chakra-ui/react';

export const StyledTh: React.FC<TableColumnHeaderProps> = (props) => (
  <Th fontSize="xs" paddingX={2} paddingY={2} {...props} />
);

export const StyledTd: React.FC<TableCellProps> = (props) => (
  <Td fontSize="xs" paddingX={2} paddingY={2} {...props} />
);
